import {createContext} from 'react';
import {RadioGroupContextProps} from 'app/components/sharedReactComponents/RadioGroup';

export const RadioGroupContext = createContext<RadioGroupContextProps>({});
